let _ = t => t,
  _t;
import { colors } from '@ovpn-ui/styles';
import styled from 'styled-components';
import { fontStack, shadows } from '../../../styles';
const variantWidth = {
  button: '224px',
  input: '100%'
};
export const DropdownMenu = styled.div(_t || (_t = _`
    position: absolute;

    z-index: 99;

    display: flex;

    flex-direction: column;

    width: ${0};

    height: 600;

    max-height: 600px;

    padding: 8px;

    overflow: hidden;

    color: ${0};

    background-color: ${0};

    border: 1px solid ${0};

    border-radius: 4px;

    box-shadow: ${0};

    transform: translateY(4px);

    ${0}

    hr {
        border: 1px solid ${0};
        border-top: none;
    }
`), props => {
  var _props$variant;
  return variantWidth == null ? void 0 : variantWidth[(_props$variant = props == null ? void 0 : props.variant) != null ? _props$variant : 'input'];
}, colors.neutralTextSubtitle, colors.neutralWhite, colors.neutralLight, shadows.sm, fontStack.textSm, colors.neutralBgHover);